<template>
    <v-container>
        <v-breadcrumbs :items="breadcrumbs" large></v-breadcrumbs>

        <v-card class="mb-10">
            <v-card-text>
                <v-form @submit.prevent="formEdit" ref="refEditPage" lazy-validation>
                    <v-row>
                        <v-col cols="12" sm="12" md="8">
                            <div class="mb-3">
                                <strong>Slug:</strong> {{ tmpDomain }}{{ slug }}/my/<a>{{ data.slug }}</a>
                            </div>
                            <v-text-field
                                label="Título *"
                                dense
                                outlined
                                :rules="[rules.required]"
                                v-model="data.title"
                                :error="(errors['title']) ? true : false"
                                :error-messages="(errors['title']) ? errors['title'][0] : ''"
                                @blur="generateSlug"
                            ></v-text-field>
                            <vue-editor v-model="data.content" :editor-toolbar="customToolbar" />
                        </v-col>
                        <v-col cols="12" md="4" class="text-center">
                            <!-- status -->
                            <v-switch
                                v-model="data.state"
                                inset
                                :label="`Estado: ${(data.state)?'activo':'inactivo'}`"
                            ></v-switch>
                            <!-- end status -->
                            Imagen principal *
                            <div style="position: relative; width:250px" class="mb-6 mx-auto">
                                <v-img
                                    :src="previewImg"
                                    height="80"
                                    style="background-color: grey"
                                ></v-img>
                                <v-btn
                                    absolute
                                    dark
                                    fab
                                    bottom
                                    right
                                    @click="openInputFile"
                                >
                                    <v-icon>mdi-image</v-icon>
                                </v-btn>
                                <input type="file" @change="upBanner" class="d-none" ref="fileInput" accept="image/png, image/jpeg">
                            </div>
                            <span class="red--text" v-if="errors['banner']">{{ (errors['banner']) ? errors['banner'][0] : '' }}</span>
                        </v-col>
                        <v-col cols="12" sm="12" class="text-center">
                            <v-btn type="submit" color="primary" :loading="loading">
                                Actualizar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>
<script>
// import { TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History } from 'tiptap-vuetify'
export default {
    // components: { TiptapVuetify },
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Páginas',
                    disabled: false,
                    href: '/admin/pages',
                },
                {
                    text: 'Crear página',
                    disabled: true,
                    href: '',
                }
            ],
            previewImg: '',
            data: {
                id: '',
                title: '',
                content: '',
                slug: '',
                banner: null,
                state: false
            },
            tmpDomain: 'http://'+window.location.hostname+'/',
            // editor
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline"],
                [{ align: "" }, { align: "center" }, { align: "right"}, { align: "justify"}],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ color: [] }],
                ['link'],
                ['image']
            ],
            // form validate
            rules: {
                required: value => !!value || 'Campo obligatorio.',
                size: value => !value || value.size < 7000000 || '¡El tamaño de la foto debe ser inferior a 2 MB!',
            },
            errors: {},
        }
    },
    props: ['dataPage', 'slug'],
    created() {
        const tmpPage = JSON.parse(this.dataPage)
        this.data.id = tmpPage.id
        this.data.title = tmpPage.title
        this.data.slug = tmpPage.slug
        this.data.content = tmpPage.content
        this.data.state = (tmpPage.state)?true:false
        this.previewImg = tmpPage.banner
    },
    methods: {
        async generateSlug(e) {
            var tmpSlug = (e.target.value).replace(/\s+/g, '-').toLowerCase()
            await axios.post('/admin/verify-slug-page', {tmpslug: tmpSlug, slug:this.slug})
            .then((response) => {
                // console.log(response)
                this.data.slug = response.data
            })
            .catch((error) => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
        // create product
        openInputFile() {
            this.$refs.fileInput.click();
        },
        upBanner(event) {
            const file = event.target.files[0];
            this.previewImg = URL.createObjectURL(file);
            this.data.banner = file;
        },
        // *************************** register ***************************//
        async formEdit() {
            if (this.$refs.refEditPage.validate()) {
                // if (this.listProd.length > 0) {
                    this.loading = true
                    this.errors = {};
                    const formData = new FormData();
                    formData.append('title', this.data.title)
                    formData.append('slug', this.data.slug)
                    formData.append('content', this.data.content)
                    formData.append('banner', this.data.banner)
                    formData.append('owner', this.slug)
                    formData.append('state', (this.data.state)?1:0)
                    formData.append('type', 'page')
                    formData.append('_method', 'PUT')

                    await axios.post(`/admin/edit-page/${this.data.id}`, formData)
                    .then(response => {
                        console.log(response);
                        if (response.data === 'ok') {
                            this.$alert('', 'Página actualizada con éxito.', 'success', {confirmButtonText: 'Continuar'})
                            // this.previewImg = ''
                            // this.data.title = ''
                            // this.data.slug = ''
                            // this.data.content = ''
                            // this.data.banner = null
                            this.$refs.refEditPage.resetValidation()
                            // this.$refs.refEditPage.reset()
                        }

                        this.loading = false
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            this.errors = error.response.data.errors
                        }
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                        this.loading = false
                    })
                // } else {
                //     this.$notify.info("Debe registrar al menos un producto.");
                // }
            }
        }
    },
}
</script>
